import { getNextElement, isFocusable } from './helpers.js'

/**
 * Handle keyboard focus inside of a swiper
 *
 * - Automatically moves to the slide where a focus occurs
 * - Enables the 'Escape' key to focus the swiper container
 *   (especially important for looping swipers which can trap keyboard focus)
 *
 * @param {import('swiper').Swiper} swiper
 */
export default function (swiper) {
  let swiperElement = swiper.el

  swiperElement.addEventListener('blur', event => {
    swiperElement.removeAttribute('tabindex')
  })

  swiperElement.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      swiperElement.setAttribute('tabindex', '-1')
      swiperElement.focus()
    }

    if (event.key === 'Tab' && !event.shiftKey && event.target === swiperElement) {
      event.preventDefault()
      getNextElement(swiperElement, isFocusable)?.focus()
    }
  })

  swiperElement.querySelector('.swiper-wrapper').addEventListener('focusin', event => {
    for (let slide of swiperElement.querySelectorAll('.swiper-slide')) {
      if (slide.contains(event.target)) {
        let index =
          'swiperSlideIndex' in slide.dataset
            ? Number(slide.dataset.swiperSlideIndex)
            : [...slide.parentNode.children].indexOf(slide)
        swiper.slideTo(index)

        if (index === 1) {
          swiperElement.focus()
        }
        break
      }
    }
  })
}
